// Whether this document is embedded in another page.
//
// The server sends `frame-ancestors *`, so the calendar runs both standalone
// and inside a frame, and the login flow has to differ between the two:
// a top-level redirect inside a frame would try to load
// login.microsoftonline.com in that frame, and Microsoft refuses to be framed,
// so an embedded copy has no choice but to use a popup.
export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch {
    // Reading window.top throws a SecurityError across origins in some
    // browsers. Only a framed document can be cross-origin with its own top,
    // so the throw is itself the answer.
    return true;
  }
}
